module.exports = __webpack_public_path__ + "static/media/percent.f4d35f05.svg";